import React from 'react';
import { FaDownload } from 'react-icons/fa6';
import { Tooltip } from 'react-tooltip';

function DownloadButton({ qrCode, className, 'aria-label': ariaLabel }) {

  return (
    <>
      <a 
        href={qrCode} 
        download="qrcode.png"
        data-tooltip-id="download-tooltip"
        data-tooltip-content="Download QR code"
        className={`${className} rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500`}
        aria-label={ariaLabel}
      >
          <FaDownload size={20} color="#68C7CC" />
        </a>
      <Tooltip id="download-tooltip" place="top" effect="solid" />
    </>
  );
}

export default DownloadButton;
